import SpotlightAdV2 from './SpotlightAdV2'

export default SpotlightAdV2
// eslint-disable-next-line import/export
export * from './SpotlightAdV2'
